import type React from 'react';

import { StarterDashboardV2TabsStateContextProvider } from './context';
import { useTabsState } from './hook';

export const StarterDashboardV2TabsStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const tabsState = useTabsState();

	return (
		<StarterDashboardV2TabsStateContextProvider value={tabsState}>
			{children}
		</StarterDashboardV2TabsStateContextProvider>
	);
};
